<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="">Период продаж за период:</label>
              <date-range-picker
                ref="picker"
                :startDate="startDate"
                opens="right"
                :ranges="ranges"
                :locale-data="date_locale"
                v-model="dateRange"
              >
              </date-range-picker>
            </div>
          </div>
        </div>
        <div>

          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button @click="setActiveTab('byPriority')" class="nav-link active" id="store-tab"
                      data-toggle="tab" data-target="#store_tab" type="button"
                      role="tab" aria-controls="store_tab" aria-selected="true">Статистика по складу
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button @click="setActiveTab('byCountry')" class="nav-link" id="country-tab" data-toggle="tab"
                      data-target="#country_tab" type="button"
                      role="tab" aria-controls="country_tab" aria-selected="false">Статистика по стране закупки
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane mt-1 fade show active" id="store_tab" role="tabpanel" aria-labelledby="store-tab">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Проект:</label>
                    <select class="form-control" v-model="filterProject" @change="updateProject(filterProject)">
                      <option value="0">Все проекты</option>
                      <option v-for="project in $AllProjects" v-if="project.is_active" :value="project.id">{{
                          project.title
                        }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Выбор приоритета:</label>
                    <select @change="showStatistics(1, true)" class="form-control" v-model="priority">
                      <option value="0">Все приоритеты</option>
                      <option value="1">Приоритет 1</option>
                      <option value="2">Приоритет 2</option>
                      <option value="3">Приоритет 3</option>
                      <option value="4">Приоритет 4</option>
                      <option value="5">Приоритет 5</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Экспорт ссылок проекта:</label>
                    <select class="form-control" v-model="selectedProject">
                      <option v-for="project in $AllProjects" v-if="project.is_active" :value="project.id">{{
                          project.title
                        }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <label for="check_1">
                  <input type="checkbox" class="from-control" v-model="filter.hideDrugs" id="check_1">
                  Не показывать препараты, которых меньше <input type="number" v-model="filter.limitQty"
                                                                 class="form-control inline"/> уп.
                </label>
                <div>
                  <input class="form-check-input ml-0" type="radio" v-model="filter.stores" id="inlineRadio2"
                         value="-1">
                  <label class="form-check-label ml-3" for="inlineRadio2">Не учитывать наличие на складах</label>
                </div>
                <div>
                  <input class="form-check-input ml-0" type="radio" v-model="filter.stores" id="inlineRadio1" value="3">
                  <label class="form-check-label ml-3" for="inlineRadio1">На складе МСК</label>
                </div>
                <div>
                  <input class="form-check-input ml-0" type="radio" v-model="filter.stores" id="inlineRadio3" value="0">
                  <label class="form-check-label ml-3" for="inlineRadio3">На всех складах</label>
                </div>
              </div>
            </div>
            <div class="tab-pane mt-1 fade" id="country_tab" role="tabpanel" aria-labelledby="country-tab">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Основные страны закупок</label>
                    <multiselect
                      class=""
                      v-model="filter.selectedCountries"
                      :options="$AllCountries"
                      :multiple="true"
                      label="name"
                      track-by="name"
                      placeholder="Выберите страны"
                      select-label="Выбрать"
                      deselect-label="Убрать страну">
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Пресеты</label>
                    <div class="flex flex_gap_5">
                      <button @click="setCountries(s)" v-for="s in selectedCountriesPreset" class="btn btn-primary"
                              type="button">
                        <span v-for="(c,i) in s">{{ i !== 0 ? ', ' : '' }}{{ allCountries[c]?.title }}</span>
                      </button>
                      <button class="btn btn-primary" @click="filter.selectedCountries = []" type="button">Сбросить
                        выбор
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="text-right">
          <LoadingButton
            v-if="(records[filter.requestType] ?? []).length"
            title="Экспорт в XLSX"
            className="btn btn-outline-success"
            :loading="loading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => showStatistics(1, false, true)"
          />
          <LoadingButton
            title="Показать"
            className="btn btn-outline-info"
            :loading="loading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => showStatistics(1, true)"
          />
        </div>
      </div>
    </div>

    <div class="card" v-if="(records[filter.requestType] ?? []).length || loading">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading">
          <div class="flex justify-content-between">
            <div><span v-if="paginator">Всего препаратов: <strong>{{ paginator.total }}</strong></span></div>
            <div class="text-right">
              <paginate v-if="paginator"
                        v-model="paginator.current_page"
                        :page-count="paginator.last_page"
                        :page-range="11"
                        :margin-pages="2"
                        :click-handler="showStatistics"
                        :prev-text="'&laquo'"
                        :next-text="'&raquo'"
                        :container-class="'pagination'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :active-class="'active green_btn'">
              </paginate>
            </div>
          </div>
          <template v-if="filter.requestType === 'byPriority'">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th width="100px">ID</th>
                <th width="100px">Приоритет</th>
                <th>Препарат</th>
                <th class="fix_width">
                <span @click="updateSort('sold')" v-bind:class="{'active': activeSort.sold, 'sortable': true}"><i
                  v-if="activeSort.field === 'sold'"
                  v-bind:class="{'icon-fa icon-fa-sort-amount-desc' : activeSort.desc, 'icon-fa icon-fa-sort-amount-asc' : !activeSort.desc, }"></i>
                  Продано</span>
                </th>
                <th class="fix_width">
                <span @click="updateSort('price')" v-bind:class="{'active': activeSort.price, 'sortable': true}"><i
                  v-if="activeSort.field === 'price'"
                  v-bind:class="{'icon-fa icon-fa-sort-amount-desc' : activeSort.desc, 'icon-fa icon-fa-sort-amount-asc' : !activeSort.desc, }"></i>
                  Сумма</span>
                </th>
                <th class="fix_width">Средняя цена
                </th>
                <th class="fix_width">
                <span @click="updateSort('mainStore')" v-bind:class="{'active': activeSort.sold, 'sortable': true}"><i
                  v-if="activeSort.field === 'mainStore'"
                  v-bind:class="{'icon-fa icon-fa-sort-amount-desc' : activeSort.desc, 'icon-fa icon-fa-sort-amount-asc' : !activeSort.desc, }"></i>
                  Наличие МСК</span>
                </th>
                <th class="fix_width">
                <span @click="updateSort('allStores')" v-bind:class="{'active': activeSort.sold, 'sortable': true}"><i
                  v-if="activeSort.field === 'allStores'"
                  v-bind:class="{'icon-fa icon-fa-sort-amount-desc' : activeSort.desc, 'icon-fa icon-fa-sort-amount-asc' : !activeSort.desc, }"></i>
                  Наличие Все</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="recordsLoading">
                <td colspan="10">
                  <pulse-loader :loading="recordsLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
                </td>
              </tr>
              <tr v-if="!recordsLoading" v-for="record in records[filter.requestType]" :key="record.id">
                <td>{{ record.id }}</td>
                <td>
                  <select @change="updateDrug($event.target.value, record.id)" class="form-control">
                    <option :selected="1 == record.priority" value="1">1</option>
                    <option :selected="2 == record.priority" value="2">2</option>
                    <option :selected="3 == record.priority" value="3">3</option>
                    <option :selected="4 == record.priority" value="4">4</option>
                    <option :selected="5 == record.priority" value="5">5</option>
                  </select>
                </td>
                <td>{{ record.title }}</td>
                <td>{{ record.totalQty }}</td>
                <td>{{ record.totalPrice }}</td>
                <td>{{ Math.round(record.totalPrice / record.totalQty) }}</td>
                <td>{{ Math.round(record.inMainStore * 10) / 10 }}</td>
                <td>{{ Math.round(record.inAllStores * 10) / 10 }}</td>
              </tr>
              </tbody>
            </table>
          </template>
          <template v-if="filter.requestType === 'byCountry'">
            <div class="mb-1">

              <p>за <strong>{{ dayStats }}</strong> день(й), средние продажи в день</p>
              <p><strong>{{Math.round(groupCountry.reduce((acc, g) => acc + g.total_qty, 0) / dayStats)}}</strong> общие продажи в день</p>
              <p><strong>{{
                  Math.round(groupCountry.filter((g) => filter.selectedCountries.length ? filter.selectedCountries.map((c) => c.id).includes(g.income_country_id) : true).reduce((acc, g) => acc + g.total_qty, 0) / dayStats)
                }}</strong>:
                все выбранные страны</p>
              <p
                v-for="g in sortArray(groupCountry, 'total_qty', 'desc').filter((g) => filter.selectedCountries.map((c) => c.id).includes(g.income_country_id))">
                <strong>{{ Math.round(g.total_qty / dayStats) }}</strong>: {{
                  allCountries[g.income_country_id]?.name
                }}
              </p>
            </div>

            <SaleDrugsTableByCountry :records="records[filter.requestType]"
                                     :days="dayStats"
                                     :currentPage="paginator.current_page"/>
          </template>
          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      :page-range="11"
                      :margin-pages="2"
                      :click-handler="showStatistics"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api"
import LoadingButton from '@/components/buttons/LoadingButton'
import {TableComponent, TableColumn} from 'vue-table-component'
import moment from "moment";
import DateRangePicker from 'vue2-daterange-picker'
import Paginate from 'vuejs-paginate'
import Multiselect from "vue-multiselect";
import SaleDrugsTableByCountry from "@/views/statistics/components/SaleDrugsTableByCountry.vue";

export default {
  components: {
    SaleDrugsTableByCountry,
    Multiselect,
    LoadingButton,
    TableComponent,
    TableColumn,
    Paginate,
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      priority: 0,
      filterProject: 0,
      selectedProject: 0,
      recordsLoading: false,
      startDate: '2022-01-01',
      activeSort: {},
      selectedCountriesPreset: [
        [5, 2, 12, 11, 9, 10, 8, 14, 25, 21],
      ],
      allCountries: {},
      dayStats: 0,
      groupCountry: [],
      filter: {
        requestType: 'byPriority',
        selectedCountries: [],
        hideDrugs: false,
        stores: -1,
        limitQty: 0
      },
      dateRange: {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek'),
      },
      date_locale: {
        firstDay: 1,
        format: 'DD-MM-YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
      indexes: null,
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        // 'Сегодня': [moment(), moment()],
        // 'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      statDays: 30,
      paginator: null,
      records: {}
    }
  },
  created() {
    this.showStatistics();
    this.allCountries = this.$AllCountries.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllProjects() {
      const records = this.$store.getters['platform/projects'].filter((s) => s.id && s.id !== 4)
      return _.orderBy(records, 'id');
    },
  },
  methods: {
    setCountries(set) {
      this.filter.selectedCountries = this.$AllCountries.filter((c) => set.includes(c.id));
    },
    setActiveTab(alias) {
      this.filter.requestType = alias;
      this.activeSort = {};
    },
    async updateDrug(priority, drugId) {
      const {data} = await api.post('/new/drugs/update', {
        drugId: drugId,
        type: 'updateField',
        fields: {
          priority: priority
        }
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка сервера!');
      } else {
        toastr['success'](data.message || 'Препарат обновлен!');
      }
    },
    updateSort(title) {
      if (!this.activeSort.field || this.activeSort.field !== title) {
        this.activeSort = {field: title, desc: false}
      }
      this.activeSort.desc = !this.activeSort.desc;
      this.showStatistics();
    },
    updateProject(id) {
      this.selectedProject = id;
    },
    async showStatistics(page = 1, newRange = false, exportXLS = false) {
      let projectLinks = null;
      if (this.selectedProject) {
        projectLinks = this.selectedProject;
      } else if (this.filterProject) {
        projectLinks = this.filterProject;
      }
      if (exportXLS && !projectLinks) {
        toastr['warning']('Выберите Проект или Экспорт ссылок проекта');
        return false;
      }

      if (this.records[this.filter.requestType] && this.records[this.filter.requestType].length || exportXLS) {
        this.recordsLoading = true;
      }
      if (newRange) {
        this.activeSort = {}
        this.loading = true;
      }
      let {data: r_data} = await api.post('/statistics/saleStat', {
        page,
        exportXLS,
        project: this.filterProject,
        projectLinks: projectLinks,
        priority: this.priority,
        dateRange: this.dateRange,
        activeSort: this.activeSort,
        filter: {
          ...this.filter,
          selectedCountries: this.filter.selectedCountries.map((c) => c.id),
        }
      });
      if (!r_data.success) {
        toastr['warning'](r_data.message || 'Ошибка сервера!');
      } else {
        if (!exportXLS) {
          this.dayStats = r_data.days_stats;
          this.groupCountry = r_data.group_country;
          const {data, ...pagination} = r_data.records
          this.paginator = pagination
          this.$set(this.records, this.filter.requestType, data);
        } else {
          window.location.href = r_data.link;
        }
      }
      this.loading = false;
      this.recordsLoading = false;
    }
  }
}

</script>

<style scoped>
input.inline {
  width: 70px;
  display: inline;
}

.table .sortable {
  cursor: pointer;
  background-color: lightgray;
  padding: 2px 7px;
  border-radius: 5px;
}

.fix_width {
  width: 140px;
}

p {
  margin-bottom: 0;
}
</style>
